var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cemetery-view" }, [
    _c(
      "div",
      { staticClass: "cemetery-details" },
      [
        _c("MaterialSlideShow", {
          staticClass: "slide_fixed_height",
          attrs: {
            smallNavigation: true,
            bulletss: false,
            slides: _vm.cemeteryImages,
            imageKey: "url",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-content pt-3" }, [
          _c("div", { staticClass: "cemetery-detail-header" }, [
            _c("div", { staticClass: "cemetery-info" }, [
              _c("div", { staticClass: "wrapper row flex-column no-gutters" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-sm d-flex" }, [
                      _c("div", { staticClass: "cemetery-status-id" }, [
                        _c("h3", { staticClass: "cemetery-id" }, [
                          _c("div", { staticClass: "main-title" }, [
                            _c("span", [_vm._v(_vm._s(_vm.cemeteryName))]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "cemetery-status" }, [
                            _vm._v(
                              "\n                                                Público\n                                            "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.allowViewDetail
                      ? _c("div", { staticClass: "col-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "cemetery-view-btn btn btn-outline-secondary-main",
                              attrs: {
                                type: "button",
                                "aria-label": `view ${_vm.cemeteryName}`,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onViewDetailCemetery.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("span", [
                                _c("i", {
                                  staticClass:
                                    "far fa-rectangle-list view-icon",
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-icon" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        `${_vm.baseTranslateID}.buttons.view`
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm.numActiveTabs > 1
              ? _c(
                  "ul",
                  {
                    staticClass: "nav nav-tabs mb-3",
                    attrs: { role: "tablist" },
                  },
                  _vm._l(_vm.activeTabs, function (tab, index) {
                    return _c(
                      "li",
                      { key: `tab-${index}`, staticClass: "nav-item" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link",
                            class: { active: _vm.selectedTab.id == tab.id },
                            attrs: {
                              "data-toggle": "tab",
                              role: "tab",
                              id: `item-${tab.id}-tab`,
                              href: "javascript:void(0);",
                              "aria-controls": `item-${tab.id}`,
                              "aria-selected": _vm.selectedTab.id == tab.id,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.activeTab = tab
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t(tab.name)) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content" },
              _vm._l(_vm.activeTabs, function (tab) {
                return _c(
                  "div",
                  {
                    key: `tab-pane-${tab.id}`,
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.selectedTab.id == tab.id },
                    attrs: {
                      role: "tabpanel",
                      id: `item-${tab.id}`,
                      "aria-labelledby": `item-${tab.id}-tab`,
                    },
                  },
                  [
                    _c(tab.component, {
                      tag: "component",
                      attrs: {
                        panelCfg: _vm.panelCfg,
                        additional: _vm.additional,
                        parentId: _vm.parentId,
                        baseTranslateID: tab.baseTranslateID,
                      },
                      model: {
                        value: tab.model,
                        callback: function ($$v) {
                          _vm.$set(tab, "model", $$v)
                        },
                        expression: "tab.model",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }